import { FileText, Upload, Pencil, Trash2, Download, Users, UserPlus, Lock, Globe, AlertTriangle, Clock, CheckCircle, XCircle, ShieldAlert } from 'lucide-react';

export const API = '/api';

// Document type labels and colors
export const DOCUMENT_TYPES = {
  will: { label: 'Will', color: 'bg-purple-100 text-purple-700' },
  trust: { label: 'Trust', color: 'bg-blue-100 text-blue-700' },
  power_of_attorney: { label: 'Power of Attorney', color: 'bg-amber-100 text-amber-700' },
  healthcare_directive: { label: 'Healthcare Directive', color: 'bg-rose-100 text-rose-700' },
  insurance: { label: 'Insurance Policy', color: 'bg-green-100 text-green-700' },
  deed: { label: 'Property Deed', color: 'bg-cyan-100 text-cyan-700' },
  financial: { label: 'Financial Document', color: 'bg-indigo-100 text-indigo-700' },
  other: { label: 'Other', color: 'bg-gray-100 text-gray-700' }
};

// Visibility options
export const VISIBILITY_OPTIONS = [
  { value: 'owner_only', label: 'Private', icon: Lock, description: 'Only you can view', color: 'text-red-600 bg-red-50' },
  { value: 'executors', label: 'Executors', icon: Users, description: 'You + designated executors', color: 'text-amber-600 bg-amber-50' },
  { value: 'all_members', label: 'All Members', icon: Globe, description: 'All family members', color: 'text-green-600 bg-green-50' }
];

// Audit action labels and icons
export const AUDIT_ACTIONS = {
  document_upload: { label: 'Uploaded', icon: Upload, color: 'text-green-600' },
  document_view: { label: 'Viewed', icon: FileText, color: 'text-blue-600' },
  document_download: { label: 'Downloaded', icon: Download, color: 'text-indigo-600' },
  document_edit: { label: 'Edited', icon: Pencil, color: 'text-amber-600' },
  document_delete: { label: 'Deleted', icon: Trash2, color: 'text-red-600' },
  executor_added: { label: 'Executor Added', icon: UserPlus, color: 'text-teal-600' },
  executor_removed: { label: 'Executor Removed', icon: Users, color: 'text-orange-600' },
  visibility_changed: { label: 'Visibility Changed', icon: Lock, color: 'text-purple-600' },
  emergency_access_requested: { label: 'Emergency Access Requested', icon: AlertTriangle, color: 'text-red-600' },
  emergency_access_approved: { label: 'Emergency Access Approved', icon: CheckCircle, color: 'text-green-600' },
  emergency_access_denied: { label: 'Emergency Access Denied', icon: XCircle, color: 'text-red-600' },
  emergency_access_auto_granted: { label: 'Emergency Access Auto-Granted', icon: Clock, color: 'text-amber-600' },
  emergency_access_revoked: { label: 'Emergency Access Revoked', icon: ShieldAlert, color: 'text-red-600' }
};

// Emergency access status labels
export const EMERGENCY_STATUS = {
  pending: { label: 'Pending', color: 'bg-amber-100 text-amber-700', icon: Clock },
  approved: { label: 'Approved', color: 'bg-green-100 text-green-700', icon: CheckCircle },
  denied: { label: 'Denied', color: 'bg-red-100 text-red-700', icon: XCircle },
  auto_granted: { label: 'Auto-Granted', color: 'bg-blue-100 text-blue-700', icon: Clock },
  revoked: { label: 'Revoked', color: 'bg-gray-100 text-gray-700', icon: ShieldAlert }
};
